import React, { memo, forwardRef } from "react";
import clsx from "clsx";
import { ScrollSyncPane } from "react-scroll-sync";
import { HeaderGroup } from "react-table";

import { ReactComponent as ArrowIcon } from "static/images/arrow.svg";
import styles from "./table.module.scss";

type TableHeaderProps = {
	header: HeaderGroup;
	minWidth?: string;
	classNameHeader?: string;
};

const ArrowComponent = ({ column }) => {
	return column.canSort ? (
		column.isSorted ? (
			column.isSortedDesc ? (
				<ArrowIcon className={styles.descArrow} />
			) : (
				<ArrowIcon className={styles.ascArrow} />
			)
		) : (
			<ArrowIcon className={styles.inactiveArrow} />
		)
	) : null;
};

// TODO: Optimize rerendering.
// It rerenders on each tick. Because of header prop
const TableHeader = forwardRef<HTMLDivElement, TableHeaderProps>(
	({ header, minWidth, classNameHeader }, ref) => (
		<ScrollSyncPane group="horizontal">
			<div
				className={`${styles.headers} ${classNameHeader}`}
				{...header.getHeaderGroupProps()}
			>
				<div
					className={styles.headersInner}
					style={{ minWidth }}
					ref={ref}
				>
					{header.headers.map((column: any) => (
						<div
							{...column.getHeaderProps({
								...column.getSortByToggleProps(),
								style: column?.headerStyle,
								className: clsx(
									styles.header,
									column.classNameHeader,
									column.alignRight && styles.alignRight,
									column.isSticky && styles.isSticky,
								),
							})}
						>
							<div className={styles.headerName}>
								<span className={styles.text}>
									{column.render("Header")}
								</span>
								<span className={styles.icon}>
									<ArrowComponent column={column} />
								</span>
							</div>
							{column.canFilter && (
								<div className={styles.headerFilter}>
									{column.render("Filter")}
								</div>
							)}
						</div>
					))}
				</div>
			</div>
		</ScrollSyncPane>
	),
);

const Component = memo(TableHeader);
export { Component as TableHeader };
